export const SESSION_TYPES = {
  GAME: 'GAME',
  TRAINING: 'TRAINING',
  OTHER: 'OTHER',
  INDIVIDUAL: 'INDIVIDUAL'
}

export const SESSION_ENTITIES = {
  ALL: 'ALL',
  TEAM: 'TEAM',
  INDIVIDUAL: 'INDIVIDUAL'
}

export const SESSION_METRICS = {
  TIME_ABOVE_80_PERCENT_HR: 'TIME_ABOVE_80_PERCENT_HR',
  AP: 'AP',
  DISTANCE: 'DISTANCE',
  WORKLOAD: 'WORKLOAD'
}

export const SESSION_METRICS_STATE_KEYS = {
  TIME_ABOVE_80_PERCENT_HR: 'TIME_ABOVE_80_PERCENT_HR',
  AP: 'AP_PERCENTAGE',
  DISTANCE: 'DISTANCE',
  WORKLOAD: 'WORKLOAD'
}

export const SEGMENT_METRICS = {
  HR: 'HR',
  AP: 'AP',
  DISTANCE: 'DISTANCE',
  WORKLOAD: 'WORKLOAD'
}

export const TIME_ABOVE_80_PERCENT_HR_UNITS = {
  BPM: 'BPM',
  PERCENTAGE: 'PERCENTAGE'
}

export const AP_ZONES_UNITS = {
  PERCENTAGE: 'PERCENTAGE',
  TIME_IN_MINUTES_SECONDS: 'TIME_IN_MINUTES_SECONDS'
}

export const WORKLOAD_ZONES_UNITS = {
  PERCENTAGE: 'PERCENTAGE',
  TRIMPS: ''
}

export const DISTANCE_ZONES_UNITS = {
  PERCENTAGE: 'PERCENTAGE',
  METERS: 'METERS'
}

export const ATTACHMENT_TYPES = {
  LINK: 'LINK',
  FILE: 'FILE'
}

export const ACTIVITY_STATUS = {
  INVALID: 'INVALID',
  PROCESSED: 'PROCESSED',
  NOT_SYNCED: 'NOT_SYNCED',
  NOT_PROCESSED: 'NOT_PROCESSED',
  FAILED: 'FAILED',
  BELT_NOT_WORN: 'BELT_NOT_WORN'
}